var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BgManualMarkers"},_vm._l((_vm.points),function(point){return _c('div',{key:point.id,class:`BgManualMarkers__marker ${
      point.id === _vm.selectedId ? 'BgManualMarkers__marker--active' : ''
    }`,style:({ left: _vm.getLeft(point.timestamp_top) }),attrs:{"title":"Manual feedback"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('select', point.id)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }